<template>
    <v-container fluid>
        <div v-if="loading">
            <Loading/>
        </div>
        <div v-if="!loading">
            <v-row no-gutters class="btn-group">
                <v-col cols="5">
                    <v-btn
                    class="primary btn"
                    height="45"
                    style="border-radius: 30px;"
                    v-on:click="goBack">Go back
                    </v-btn>
                </v-col>
            </v-row>
            <v-row justify="start">
                <v-col>
                    <h3 class="black--text">Enter your mobile number and email address</h3>
                </v-col>
            </v-row>
            <v-row justify="center" class="div2" >
                <v-col :style="$vuetify.breakpoint.smAndDown ? 'display: block' : 'display: flex;'">
                    <v-text-field background-color="grey lighten-3" solo type="number" label="Mobile number eg: 0671234567" v-model="mobile"></v-text-field>
                    <v-text-field :class="$vuetify.breakpoint.smAndDown ? '' : 'ml-4'" background-color="grey lighten-3" solo label="Enter your email address" v-model="emailAddress"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn rounded outlined style="border: 1px solid black;" height="60" class="min-width primary white--text" v-on:click="sendQuote" :disabled="disabled">Proceed</v-btn>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
import { getFunctions, httpsCallable } from 'firebase/functions'
import { addDoc, getFirestore, collection } from '@firebase/firestore';
import Loading from "@/components/Loading";
import { trackEvent } from '@/utils/analytics';
const db = getFirestore();
const functions = getFunctions();
const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3}?)[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/

export default {
  name: "ConfirmInfo",
  props: {
    wasteType: Object,
    vehicle: Object,
    capturedAddress: String,
    location: Object,
    postCode: String,
    nextStep: Function,
    goBack: Function
  },
  components:{
    Loading
  },
  data() {
    return {
      booking: {},
      isSendingEmail: false,
      timeStamp: new Date(),
      user: {},
      emailAddress: '',
      mobile: '',
      loading: false,
      disabled: false
    }
  },
  methods: {
    checkEmail(){
      let emails = this.$store.state.fastQuote.emails;
      if (emails.length === 4 && emails.includes(this.emailAddress)) {
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: 'This email has been used multiple times',
          options: {
            timeout: 3000
          }
        });
        return false;
      } 
      if (emails.length === 4 && !emails.includes(this.emailAddress)) {
        this.$store.state.fastQuote.emails = [];
        this.$store.commit("setEmails", this.emailAddress);
        return true;
      } else {
        this.$store.commit("setEmails", this.emailAddress);
        return true;
      }
    },
    async sendPipeDriveDeal(){
       // send deal to pipedrive 
       let user = {
        name: "NA",
        email: this.emailAddress,
        phone: this.mobile
      };
      let deal = {
        title: `Quote #${Number.parseInt(this.order) + 1}`,
        value: this.vehicle.cost,
        currency: "ZAR",
        status: "open",
        pipeline_id: 1
      }; 
      this.$store.dispatch("sendPipeDriveDeal", {
        user: user,
        deal: deal
      });
      setTimeout(() => {
        this.nextStep();
        this.loading = false;
      }, 1000);
    },
    sendQuote() {
      this.loading = true;
      if (!this.checkEmail()) {
        this.loading = false;
        return;
      }
      if(!phoneRegex.test(this.mobile)){
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: 'Missing or incorrect email or phone number!',
          options: {
            timeout: 3000
          }
        });
        this.loading = false;
        return;
      }
      else if(!this.emailAddress){
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: 'Missing or incorrect email address!',
          options: {
            timeout: 3000
          }
        });
        this.loading = false;
        return;
      }
      else{
        this.disabled = true;
        window.scrollTo(0, 0);
        const sendFastQuote = httpsCallable(functions, 'sendFastQuote');
        const successCallback = () => {
          // send deal to pipedrive 
          this.sendPipeDriveDeal();
        };
        const errorCallback = () => {
          this.$store.dispatch('toastr/addToastr', {
            id: `toast-${Date.now()}`,
            type: 't-danger',
            title: 'Invalid',
            message: 'Invalid email address ' + this.emailAddress,
            options: {
              timeout: 3000
            }
          });
          // send deal to pipedrive 
          this.sendPipeDriveDeal();
        };

        this.saveQuote().then((snapshot) => {
          const quoteId = snapshot.id;
          this.$store.dispatch('fetchQuoteId', quoteId);
          trackEvent('quote_submitted', {
            quote_source: 'fast_quote',
            waste_type: this.wasteType.name,
            vehicle_name: this.vehicle.name
          });
          sendFastQuote({ ...this.booking, emailAddress: this.emailAddress, quoteId: quoteId })
              .then(function() {
                successCallback();
              })
              .catch((error) => {
                errorCallback();
                console.log(error);
              });
        }).catch((error) => {
          this.loading = false;
          console.log(error);
          this.$store.dispatch('toastr/addToastr', {
            id: `toast-${Date.now()}`,
            type: 't-warning',
            title: 'Alert',
            message: 'Something went wrong, please try again later',
            options: {
              timeout: 3000
            }
          });
        });
      }
    },
    async saveQuote() {
      this.buildBooking();
      let dataRef = collection(db, 'quotes');
      return addDoc(dataRef, this.booking).then((snapshot) => {
        return snapshot;
      });
    },
    buildBooking() {
      this.booking = {
        order: Number.parseInt(this.order + 1),
        orderNumber:{
          id: 1000, //starting the order id at 1000
          number: 1000
        },
        waste: {
          type: this.wasteType.key,
          name: this.wasteType.name
        },
        vehicle: {
          type: this.vehicle.type,
          name: this.vehicle.name
        },
        drivers: this.vehicle.drivers.map(d => d.id),
        driversTokens: this.vehicle.drivers.map(d => d.token ? d.token : ''),
        driverMobiles: this.vehicle.drivers.map(d => '+27' + d.mobile.substring(1,10)),
        customer:{
          mobile: this.mobile,
          emailAddress: this.emailAddress
        },
        cost: {
          currency: 'ZAR',
          symbol: 'R',
          value: this.vehicle.cost,
          fuelLevy: this.fuelLevyPrice
          //discount: this.cost
        },
        capturedAddress: this.capturedAddress,
        postCode: this.location.postal_code ? this.location.postal_code : this.postCode,
        lat: this.location.latitude,
        long: this.location.longitude,
        status: {
          type: 'QUOTE',
          status: 'QUOTE'
        },
        timeStamp: this.timeStamp
      };
    }
  },
  computed:{
    order(){
      return this.$store.getters.getOrder;
    },
    fuelLevyPrice() {
      return this.$store.state.fuelLevy.fuelLevyPrice;
    }
    /*cost(){
      let actualCost = parseInt(this.vehicle.cost);
      return actualCost - (actualCost * 0.1);
    }*/
  },
  async mounted() {
    this.$store.dispatch('fetchOrder');
  }
}
</script>

<style scoped>
.head1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750px;
  font-size: 56px;
  line-height: 64px;
}
.min-width {
  width: 150px;
}
.btn{
  width: 200px;
}

</style>
